import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Col, Grid, Row, FormGroup } from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import { Link } from "react-router-dom";


class SubstancesAnalysesForm extends React.Component {

    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            vSubstanceClasse: '',
            vClasse: '',
            nomSubstance: '',
            result: {
                status:null,
                data:"Après avoir selectionner vos données appuyer sur le button ci-dessous pour lancer l'analyse "
            }
        }
    }
    onChangeClasse = classe => {
        this.state.vClasse = classe.value.toLowerCase();
    }

    onChangeSubstance = substance => {

        if(substance.classesContresIndiquees== undefined){
            substance.classesContresIndiquees =''
        }

        if(substance.classesContresIndiquees.includes(',')){
            this.state.vSubstanceClasse = substance.classesContresIndiquees.split(",");
            this.state.id = substance.value;
            this.state.nomSubstance = substance.label.toUpperCase();
        }
        else{
            this.state.vSubstanceClasse = substance.classesContresIndiquees;
            this.state.id = substance.value;
            this.state.nomSubstance = substance.label;
        }
    }



    onChangeOption = option => {
        this.state.AOption = option.value;
    }

    onSubmit(event) {
        event.preventDefault();

    }

    render() {
        return (
            <div className="main-content" >
                <Grid fluid style={{ padding:'5%',background:'#81DAF5'}} >
                    <form onSubmit={this.onSubmit}>
                        <p className="text-center" style={{padding:'20px', fontSize: '30px', color:'black', background:'#EFFBFB'}}>
                            Veuillez selectionnez le mode d'analyse !
                        </p>
                        <Card
                            content=
                                {<Grid fluid className="text-center" style={{background:'white'}}>
                                    <Row>
                                        <Col xs={12} sm={6} md={6}>
                                            <FormGroup style={{padding:'10px' }}>
                                                <Link to={`/app/analyse/substance/`}>
                                                    <Button fill type="submit" bsStyle="info" style={{fontSize:"2rem", borderRadius:"20%", padding:'10px' }}>
                                                        DCI Vers DCI
                                                    </Button>
                                                </Link>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} sm={6} md={6}>
                                            <FormGroup style={{padding:'10px' }}>
                                                <Link to={`/app/analyse/classe/`}>
                                                    <Button fill type="submit" bsStyle="info" style={{fontSize:"2rem", borderRadius:"20%"}}>
                                                        DCI Vers Classe Pharmacologique
                                                    </Button>
                                                </Link>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} sm={6} md={6}>
                                            <FormGroup style={{padding:'10px' }}>
                                                <Link to={`/app/analyse/product/`}>
                                                    <Button fill type="submit" bsStyle="info" style={{fontSize:"2rem", borderRadius:"20%"}}>
                                                        DCI Vers Nom Commercial
                                                    </Button>
                                                </Link>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} sm={6} md={6}>
                                            <FormGroup style={{padding:'10px' }}>
                                                <Link to={`/app/analyse/nomCommercial/`}>
                                                    <Button fill type="submit" bsStyle="info" style={{fontSize:"2rem", borderRadius:"20%"}}>
                                                        Nom Commercial Vers Nom Commercial
                                                    </Button>
                                                </Link>
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                </Grid>
                                }/>

                    </form>
                </Grid>

            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        message: state.status.message,
        loading: state.status.loading,
        substance: state.substances.substance,
    }
};

SubstancesAnalysesForm.propTypes = {
    match: PropTypes.object,
    message: PropTypes.object,
    loading: PropTypes.bool,
    showNotification: PropTypes.func,
    Substance: PropTypes.object,
};

export default connect(mapStateToProps)(SubstancesAnalysesForm);